import React, { useState, useEffect } from 'react';
import Header from './Header';
import Sidebar from './Sidebar';
import { Outlet } from 'react-router-dom';

export default function Layout({ children }) {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 768);

    useEffect(() => {
        const handleResize = () => {
            const desktop = window.innerWidth >= 768;
            setIsDesktop(desktop);
            // Close sidebar automatically when switching to desktop
            if (desktop) {
                setIsSidebarOpen(false);
            }
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    return (
        <div className='min-h-screen bg-gray-50'>
            {/* Fixed Header */}
            <div className='fixed top-0 left-0 right-0 z-50'>
                <Header isSidebarOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
            </div>

            {/* Main Content Area */}
            <div className='flex pt-16 lg:pt-20 min-h-screen'>
                {/* Sidebar - Desktop always visible, Mobile slides in */}
                <div 
                    className={`
                        ${isDesktop ? 'block' : 'fixed top-0 left-0 z-40 h-full'}
                        ${!isDesktop && `transition-transform duration-300 ease-in-out ${isSidebarOpen ? 'translate-x-0' : '-translate-x-full'}`}
                    `}
                >
                    <Sidebar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
                </div>

                {/* Mobile Overlay */}
                {!isDesktop && isSidebarOpen && (
                    <div 
                        className='fixed inset-0 bg-black/50 backdrop-blur-sm z-30'
                        onClick={toggleSidebar}
                    />
                )}

                {/* Page Content */}
                <div className={`
                    flex-1 min-h-screen
                    transition-all duration-300
                    px-3 sm:px-4 lg:px-6
                    py-4 lg:py-6
                    ${isDesktop ? '' : ''}
                `}>
                    <div className='w-full max-w-7xl mx-auto'>
                        {children || <Outlet />}
                    </div>
                </div>
            </div>
        </div>
    );
}